export enum CarrierType {
    SELLER_DELIVERY = 5,
    CURRI_LOGISTICS = 6
}
